<template>
  <div class="view view-checkout">
    <!-- Top Bar -->
    <top-bar v-if="isPortalReady" />

    <!-- Site Content -->
    <div class="site-content" v-show="isVisible">
      <div class="container">
        <div class="row">
          <!-- Estas Comprando -->
          <div class="col-md-6">
            <h2 class="checkout-title checkout-title-primary">
              ESTAS COMPRANDO
            </h2>
            <div
              class="checkout-card checkbox checkbox-aqua"
              :class="{ 'checkbox-checked': curso.id == productoSeleccionado }"
              @click="seleccionar_producto(curso.id)"
            >
              <div class="checkout-card-image">
                <img
                    :src="require('@/assets/galerias/foto_generica.jpg')"
                  alt
                />
              </div>

              <div class="checkout-card-info">
                <div class="d-flex justify-content-between">
                  <div>
                    <div class="checkout-card-titulo">
                      {{ categoria.categoria }}
                    </div>
                    <div class="checkout-card-autor">{{ categoria.autor }}</div>
                  </div>

                  <div style="margin-top: 10px">
                    <!-- Precio Oferta -->
                    <div
                      v-if="
                        curso.precio_oferta &&
                        selectedPortalPasarela &&
                        selectedPortalPasarela.pasarela &&
                        selectedPortalPasarela.pasarela.is_movil <= 0
                      "
                      class="checkout-card-precio checkout-precio-oferta"
                    >
                      {{ formatCurrency(curso.precio_oferta) }}
                    </div>

                    <!-- Precio Suscripcion -->
                    <div
                      v-if="
                        selectedPortalPasarela &&
                        selectedPortalPasarela.pasarela &&
                        selectedPortalPasarela.pasarela.is_movil >= 1
                      "
                      :class="{
                        'checkout-card-precio':
                          selectedPortalPasarela &&
                          selectedPortalPasarela.pasarela &&
                          selectedPortalPasarela.pasarela.is_movil <= 0,
                      }"
                      style="text-align: right"
                    >
                      <div class="checkout-card-autor" style="font-size: 20px">
                        {{
                          formatCurrency(selectedPortalPasarela.pasarela.precio)
                        }}
                      </div>
                      <div class="checkout-card-titulo">
                        Cobro semanal y renovable.
                      </div>
                    </div>

                    <!-- Precio Normal -->
                    <div v-else class="checkout-card-precio">
                      <div class="checkout-card-autor">
                        {{ formatCurrency(curso.precio) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Descripcion de curso a comprar -->
            <header
              v-if="this.$route.params.suscripcion != 'suscripcion'"
              class="curso-clases-header transparente-borde"
            >
              <div class="curso-clases-descripcion text-justify texto">
                <h3 class="curso-clases-titulo-contenido">
                  ¿Qué aprenderás en este curso?
                </h3>
                <div
                  class="texto"
                  v-html="
                    curso.productos_categorias[0].categorias_productos[0]
                      .descripcion
                  "
                ></div>
              </div>
            </header>

            <!-- Link a suscripcion -->
            <p
              v-if="
                this.$route.params.suscripcion != 'suscripcion' &&
                typeof this.$route.query.operador === 'undefined' &&
                allaccess
              "
              class="checkout-or"
            >
              O TAL VEZ TE PUEDE INTERESAR
            </p>
            <div
              v-if="
                this.$route.params.id != allaccess.id &&
                typeof this.$route.query.operador === 'undefined' &&
                allaccess
              "
              class="checkout-prime checkout-check"
              :class="{
                'checkout-check-checked': allaccess.id == productoSeleccionado,
              }"
              @click="seleccionar_producto(allaccess.id)"
            >
              <div class="checkout-prime-titulo">
                {{ allaccess.producto }} POR SÓLO
                {{ formatCurrency(allaccess.precio) }}
              </div>
              <div class="checkout-prime-descripcion">
                Accede a todos los cursos de Topclass durante 1 mes.
              </div>
            </div>
          </div>
          <!-- Metodos de pago -->
          <div class="col-md-6">
            <h2 class="checkout-title">ELIGE TU METODO DE PAGO</h2>
            <!-- Pasarelas -->
            <div class="row checkout-pasarelas">
              <div
                class="col-sm-6"
                v-for="portalPasarela in pasarelasTarjetaDeCredito"
                :key="portalPasarela.pasarela.id"
              >
                <button
                  v-if="portalPasarela.pasarela.pasarela != 'compra_interna'"
                  class="checkout-pasarela btn btn-black checkbox checkbox-aqua w-100"
                  :class="{
                    'checkbox-checked':
                      selectedPortalPasarela == portalPasarela,
                    'checkbox-invalid': !portalPasarela.pasarela.visible,
                  }"
                  @click="setPortalPasarela(portalPasarela, $event)"
                >
                  <img
                    v-if="portalPasarela.pasarela.foto"
                    :src="require('@/assets/galerias/foto_generica.jpg')"
                    :alt="portalPasarela.pasarela.pasarela"
                  />
                  <span>{{
                    portalPasarela.pasarela.descripcion ||
                    portalPasarela.pasarela.pasarela
                  }}</span>
                  <span></span>
                </button>
              </div>
            </div>
            <!-- Boton de pago -->
            <div class="row">
              <div class="col">
                <button
                  id="pagar_curso"
                  class="btn btn-primary checkout-pay btn-big"
                  @click="pagar"
                >
                  <img :src="require('@/assets/images/icon-bag.svg')" alt />
                  Pagar
                  <spinner v-if="isLoadingPagoUrl" class-name="color-white" />
                </button>
                <div v-if="errorMessage != ''">
                  <div class="alert-text-box checkout-error-message">
                    {{ errorMessage }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modales -->
    <!-- Site Footer -->
    <site-footer v-if="isPortalReady" :verFooter="true" />
  </div>
</template>

<script>
import bModal from "bootstrap-vue/es/components/modal/modal";
import bModalDirective from "bootstrap-vue/es/directives/modal/modal";
import numeral from "numeral";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import TopBar from "../components/TopBar";
import { mapState, mapGetters } from "vuex";
import {
  eventKlaviyo,
  getAllAccessDeProducto,
  getCategoriaDeProducto,
  getProducto,
  getProductoDeCategoria,
} from "../utilities/data";
import { randomString, isValidEmail, isValidTelefono } from "../utilities/util";

numeral.locale("es");

export default {
  name: "CheckoutCreditCardOnly",
  components: {
    bModal,
    SiteFooter,
    Spinner,
    TopBar,
  },
  computed: {
    allaccess() {
      return this.portal.productos_portal
        ? getAllAccessDeProducto(this.portal)
        : {};
    },
    categoria() {
      return getCategoriaDeProducto(this.portal, this.curso.id);
    },
    curso() {
      return this.portal.productos_portal
        ? getProducto(this.portal, this.$route.params.id)
        : {};
    },
    ...mapState(["portal", "user", "site", "isPortalReady"]),
    pasarelasTarjetaDeCredito() {
      return this.portalPasarelas.filter((pasarela) => {
        //Filtra pasarelas por nombres ¿Cuales son las que aceptan tanjetas de credito?
        if (pasarela.pasarela.pasarela.toLowerCase() == "webpay") {
          return true;
        }
      });
    },
    producto() {
      return this.portal.productos_portal.find(
        (p) => p.id == this.$route.params.id
      );
    },
  },
  data() {
    return {
      errorMessage: "",
      fecha_entrega_share: null,
      id_compra: 0,
      id_descuento: null,
      id_user_share: null,
      isLoadingPagoUrl: false,
      isVisible: false,
      mensaje_entrega_share: null,
      productoSeleccionado: this.$route.params.id,
      portalPasarelas: [],
      selectedPortalPasarela: {},
    };
  },
  watch: {
    portal(val, old) {
      if (val) {
        if (typeof val.productos_portal !== "undefined") {
          console.log("LLamo a start por otro lado");
          //Comento segundo llamado de start para evitar llamados adicionales en los landings
          //this.start();
        }
      }
    },
  },
  methods: {
    cargar_pasarela(id_product) {
      if (
        this.portal.productos_portal.filter(
          (producto) => producto.id == id_product
        ).length > 0
      ) {
        // Cargar pasarelas del producto/portal
        this.portalPasarelas = this.portal.productos_portal
          .filter((producto) => producto.id == id_product)[0]
          .productos_pasarelas.map((pp) => {
            return {
              id_portal_pasarela: pp.id_portal_pasarela,
              pasarela: pp.productos_portal_pasarela[0].pasarelas[0],
            };
          });

        // Si existen pasarelas
        if (this.portalPasarelas.length > 0) {
          //TODO Seleccionar la primera pasarela de credito
          this.selectedPortalPasarela = this.portalPasarelas[0];
        }

        //SELECCIONAR MEOTOD PAGO
        dataLayer.push({
          event: "checkoutOption",
          ecommerce: {
            checkout_option: {
              actionField: {
                step: 2,
                option: this.selectedPortalPasarela.pasarela.pasarela,
              },
            },
          },
        });
      } else {
        // El id del curso no existe.
        this.$router.replace({ name: "error404" });
      }
    },
    formatCurrency(amount) {
      return numeral(amount).format("$0,0");
    },
    pagar() {
      //Iniciar sesion para poder comprar
      if (this.user.id == 0) {
        this.$store.commit("togglePortalRegistroModal", true);
        return false;
      }

      this.isLoadingPagoUrl = true;

      //Rut Para Pago Url
      let toSendRutPagoUrl = "";

      let pagoUrlParams = {
        id_producto:
          this.productoSeleccionado == false
            ? this.$route.params.id
            : this.productoSeleccionado,
        id_portal_pasarela: this.selectedPortalPasarela.id_portal_pasarela,
        id_moneda: this.selectedPortalPasarela.pasarela.monedas[0].id,
        id_descuento: this.id_descuento,
        id_user_share: this.id_user_share,
        total: this.producto.precio,
        rut: toSendRutPagoUrl,
        fecha_entrega: this.fecha_entrega_share,
        mensaje_entrega: this.mensaje_entrega_share,
        network:
          Object.getOwnPropertyNames(this.$route.query).length > 0
            ? this.$route.query
            : "",
        utm_source: localStorage.getItem("utm_source"),
        utm_medium: localStorage.getItem("utm_medium"),
        utm_campaign: localStorage.getItem("utm_campaign"),
      };

      //Es un Pago PostBack
      this.$api.getPagoUrl(pagoUrlParams).then((response) => {
        this.isLoadingPagoUrl = false;
        //Si hay algun mensaje
        if ("message" in response.data) {
          if (response.data.message in this.mensajes) {
            this.errorMessage = this.mensajes[response.data.message];
            return false;
          }
          return false;
        }

        this.errorMessage = "";
        this.id_compra = response.data.id_compra;

        dataLayer.push({
          event: "boton-pagar",
        });

        //CHECKOUT
        dataLayer.push({
          event: "checkout",
          ecommerce: {
            checkout: {
              actionField: { step: 3, option: "" },
              products: [
                {
                  name: this.producto.producto,
                  id: this.producto.id,
                  price: this.producto.precio,
                  category: this.categoria.categoria,
                  quantity: 1,
                },
              ],
            },
          },
        });

        // Si es pago con transferencia mostrar popup, si no, redirigir.
        if (
          this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
          "transferencia"
        ) {
          this.isTransferenciaModalVisible = true;
        }
        // Si es pago con cencosud mostrar popup, si no, redirigir.
        else if (
          this.selectedPortalPasarela.pasarela.pasarela.toLowerCase() ==
          "cencosud"
        ) {
          this.isCencosudModalVisible = true;
        } else {
          window.location = response.data.response;
        }
      });
    },
    seleccionar_producto(id_product) {
      if (this.allaccess.id == id_product) {
        this.$router.push({
          name: "checkout-prime",
          params: {
            suscripcion: "suscripcion",
            id: id_product,
          },
        });

        this.productoSeleccionado = id_product;
        this.cargar_pasarela(id_product);
        this.id_descuento = null;
        this.codigo_descuento = null;
        this.email_share = null;
        this.id_user_share = null;
      } else {
        this.productoSeleccionado = id_product;
        this.cargar_pasarela(id_product);
        this.id_descuento = null;
        this.codigo_descuento = null;
        this.email_share = null;
        this.id_user_share = null;
      }
    },
    setPortalPasarela(portalPasarela, event) {
      if (portalPasarela.pasarela.visible) {
        this.selectedPortalPasarela = portalPasarela;

        //SELECCIONAR MEOTOD PAGO
        dataLayer.push({
          event: "checkoutOption",
          ecommerce: {
            checkout_option: {
              actionField: {
                step: 2,
                option: portalPasarela.pasarela.pasarela,
              },
            },
          },
        });
      } else {
        event.preventDefault();
        return false;
      }
    },
    start() {
      this.cargar_pasarela(
        this.productoSeleccionado == false
          ? this.$route.params.id
          : this.productoSeleccionado
      );
      this.isVisible = true;
    },
  },
  created() {},
  mounted() {
    //Si el portal posee productos
    if (this.portal.productos_portal) {
      this.start();
    }
  },
};
</script>

<style>
</style>
